import { SBModel } from '@supplement-bacon/react-toolkit/models'
import { Image } from './Image'
import { Localizable } from './Localizable'

type EventBookingMethod = 'in-app' | 'chat-request'
interface Event extends SBModel, Localizable<EventLocalizable> {
  start: string
  end: string
  address?: string
  venue?: number

  maxParticipants: number
  maxMembers: number
  maxGuests: number
  maxGuestsPerParticipant: number
  bookingMethod: EventBookingMethod

  participationCutoff: number
  cancelParticipationCutoff: number
  participations?: number[]
  image: Image
  isPublished: boolean
  fillRate: number
  membershipPlans?: number[]
}

interface EventLocalizable {
  title: string
  description: string
  eventChatRequestMessage?: string
}

interface EventParticipation extends SBModel {
  membershipProfile: number
  event: number
  status: number
  firstName?: string
  lastName?: string
  email?: string
  phone?: string
  notes?: string
  checkedInAt?: string
  deletedAt?: string
}

interface ParticipationStatus extends SBModel {
  name: string
  isDefault: boolean
  icon?: string
  color?: string
}

interface EventParticipationStats {
  maxParticipants: number
  maxMembers: number
  maxGuests: number
  maxGuestsPerParticipant: number

  participationsCount: number
  membersCount: number
  guestsCount: number

  checkedIn: number
  available: number
  availableMembers: number
  availableGuests: number
}

const bookingMethodsOptions: { value: EventBookingMethod; label: string }[] = [
  { value: 'in-app', label: 'In app' },
  { value: 'chat-request', label: 'Chat request' },
]

export { bookingMethodsOptions }
export type {
  Event,
  EventParticipation,
  EventParticipationStats,
  ParticipationStatus,
}
